import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IFilterAngularComp } from 'ag-grid-angular';
import { IDoesFilterPassParams, IFilterParams } from 'ag-grid-community';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';

const TRATAMIENTO_OPTIONS = [
  'TUBERCULOSIS SENSIBLE',
  'TUBERCULOSIS FARMACORRESISTENTE',
  'QUIMIOPROFILAXIS',
  'LEPRA',
] as const;

interface TratamientoFilterModel {
  filterType: 'set';
  values: string[];
}

@Component({
  standalone: true,
  imports: [FormsModule, CheckboxModule, ButtonModule],
  template: `
    <div class="p-3 min-w-[240px]">
      <div class="flex justify-between items-center mb-2">
        <span class="text-xs font-semibold uppercase tracking-wider opacity-70">Tratamiento</span>
        <div class="flex gap-1">
          <p-button label="Todos" [text]="true" size="small" (onClick)="selectAll()" />
          <p-button
            label="Ninguno"
            [text]="true"
            size="small"
            severity="secondary"
            (onClick)="selectNone()" />
        </div>
      </div>
      @for (option of options; track option) {
        <div class="flex items-center gap-2 py-1">
          <p-checkbox
            [binary]="true"
            [ngModel]="selected[option]"
            (ngModelChange)="onCheckChange(option, $event)"
            [inputId]="'trat-' + $index" />
          <label [for]="'trat-' + $index" class="text-sm cursor-pointer select-none">{{ option }}</label>
        </div>
      }
    </div>
  `,
})
export class TratamientoFilter implements IFilterAngularComp {
  private params!: IFilterParams;
  options = TRATAMIENTO_OPTIONS;
  selected: Record<string, boolean> = {};

  agInit(params: IFilterParams): void {
    this.params = params;
    this.selectAll();
  }

  isFilterActive(): boolean {
    const count = this.selectedValues().length;
    return count > 0 && count < this.options.length;
  }

  doesFilterPass(_params: IDoesFilterPassParams): boolean {
    return true;
  }

  getModel(): TratamientoFilterModel | null {
    if (!this.isFilterActive()) return null;
    return { filterType: 'set', values: this.selectedValues() };
  }

  setModel(model: TratamientoFilterModel | null): void {
    if (!model || !model.values) {
      this.selectAll();
    } else {
      for (const opt of this.options) {
        this.selected[opt] = model.values.includes(opt);
      }
    }
  }

  onCheckChange(option: string, checked: boolean): void {
    this.selected[option] = checked;
    this.params.filterChangedCallback();
  }

  selectAll(): void {
    for (const opt of this.options) {
      this.selected[opt] = true;
    }
    this.params?.filterChangedCallback();
  }

  selectNone(): void {
    for (const opt of this.options) {
      this.selected[opt] = false;
    }
    this.params?.filterChangedCallback();
  }

  private selectedValues(): string[] {
    return this.options.filter(opt => this.selected[opt]);
  }
}
